import { useMemo } from 'react';
import { getFlagEmoji } from '@/utils/countryFlags';

export interface Country {
  id: string;
  label: string;
}

export type UseCountryListSelectProps = {
  countryList: Country[];
  value: string;
  onChange: (value: string) => void;
};

/**
 * Hook for managing selected country state
 */
export function useCountryListSelect({ value, countryList }: UseCountryListSelectProps) {
  const selectedCountry = useMemo(
    () => countryList.find(({ id }) => id === value),
    [countryList, value]
  );

  const selectedFlag = useMemo(() => {
    if (!selectedCountry) return undefined;
    return getFlagEmoji(selectedCountry.label) || getFlagEmoji(selectedCountry.id);
  }, [selectedCountry]);

  return { selectedCountry, selectedFlag };
}

